export const triggerCookieManager = function triggerCookieManager(event: Event): undefined {
  event.preventDefault();
  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
  }
};
